// extracted by mini-css-extract-plugin
module.exports = {"CardsContainer":"CardsContiner_CardsContainer__2HfSf","noTrips":"CardsContiner_noTrips__3mfm1"};